module.exports = __webpack_public_path__ + "static/mtb-11-a101822f3e6402c8c3ee671fed4d5d6e.jpg";